<nb-card>
  <nb-card-header>Mise en ambiance IA</nb-card-header>
  <nb-card-body>
    <ng-container *ngIf="!progressStarted">
      <div class="ambiance-inputs">
        <div class="ambiance-col">
          <label>{{ useReferenceAngle ? 'Vues du produit (' + selectedImages.length + '/' + maxImages + ')' : 'Photo du produit' }}</label>
          <div class="product-views">
            <div *ngFor="let url of views"
                 class="product-view"
                 [class.selected]="selectedImages.includes(url)"
                 [class.dimmed]="!useReferenceAngle && url !== mainImage"
                 [class.locked]="useReferenceAngle && url === mainImage"
                 [class.disabled]="useReferenceAngle && !selectedImages.includes(url) && selectedImages.length >= maxImages"
                 (click)="onViewClick(url)"
                 (mouseenter)="previewUrl = url"
                 (mouseleave)="previewUrl = undefined">
              <img [src]="url"
                   [class.loaded]="loadedImages.has(url)"
                   alt="Vue du produit"
                   (load)="onViewLoad(url, $event)"
                   (error)="onViewError(url)" />
            </div>
            <div *ngIf="uploadingViews" class="product-view skeleton"></div>
            <ng-container *ngIf="scraping">
              <div *ngFor="let s of skeletons" class="product-view skeleton"></div>
            </ng-container>
            <div class="product-view add-view"
                 [class.dragging]="isDraggingView"
                 title="Glissez une image ou cliquez pour importer une vue depuis votre ordinateur"
                 (click)="viewFileInput.click()"
                 (dragover)="$event.preventDefault(); isDraggingView = true"
                 (dragleave)="isDraggingView = false"
                 (drop)="onViewDrop($event)">
              <span class="add-icon">+</span>
              <span>Glissez une vue ici<br>ou cliquez pour importer</span>
            </div>
          </div>
          <input #viewFileInput type="file" accept="image/jpeg,image/png,image/webp" multiple hidden (change)="onViewFileInput($event)" />
          <input nbInput
                 fullWidth
                 type="url"
                 placeholder="… ou collez l'URL d'une vue du produit"
                 [(ngModel)]="viewUrl"
                 (change)="onViewUrlChange()" />
          <p class="views-hint" *ngIf="scraping">Recherche des autres vues du produit…</p>
          <ng-container *ngIf="!scraping && productImages.length">
            <p class="views-hint" *ngIf="!useReferenceAngle">
              Le produit gardera l'angle de la photo sélectionnée : les autres vues ne sont pas nécessaires.
              Cliquez sur une autre vue pour choisir un autre angle.
            </p>
            <p class="views-hint" *ngIf="useReferenceAngle">
              Cochez jusqu'à {{ maxImages }} vues : l'IA reproduira mieux le produit sous l'angle de la référence.
            </p>
          </ng-container>
        </div>

        <div class="ambiance-col reference-col">
          <!-- aperçu en grand de la vue survolée, par-dessus la colonne d'ambiance pour ne pas masquer la vignette -->
          <div *ngIf="previewUrl" class="view-preview">
            <img [src]="previewUrl" alt="Aperçu de la vue" />
          </div>
          <label>Image d'ambiance de référence</label>
          <div class="drop-zone"
               [class.dragging]="isDragging"
               (click)="fileInput.click()"
               (dragover)="$event.preventDefault(); isDragging = true"
               (dragleave)="isDragging = false"
               (drop)="onDrop($event)">
            <img *ngIf="ambiancePreview; else dropHint"
                 [src]="ambiancePreview"
                 class="ambiance-thumb"
                 alt="Ambiance"
                 (error)="ambiancePreview = ''" />
            <ng-template #dropHint>
              <p>Glissez une image ici<br>ou cliquez pour importer depuis votre ordinateur</p>
            </ng-template>
          </div>
          <input #fileInput type="file" accept="image/jpeg,image/png,image/webp" hidden (change)="onFileInput($event)" />
          <input nbInput
                 fullWidth
                 type="url"
                 placeholder="… ou collez l'URL d'une image"
                 [(ngModel)]="ambianceUrl"
                 (change)="onUrlChange()" />
        </div>
      </div>
      <div class="angle-option">
        <nb-toggle [(checked)]="useReferenceAngle" status="info">Reprendre l'angle du produit de la référence</nb-toggle>
        <p class="views-hint">Désactivé, le produit garde l'angle de sa photo. Activé, il prend l'angle du produit de la référence.</p>
      </div>
      <p class="hint">Votre produit sera placé dans le décor, la lumière et le style de l'image de référence.</p>
    </ng-container>

    <div *ngIf="progressStarted" class="ambiance-equation">
      <figure>
        <div class="equation-views" [class.multi]="selectedImages.length > 1">
          <img *ngFor="let url of selectedImages" [src]="url" class="equation-img" alt="Produit" />
        </div>
        <figcaption>Produit{{ selectedImages.length > 1 ? ' (' + selectedImages.length + ' vues)' : '' }}</figcaption>
      </figure>
      <span class="equation-sign">+</span>
      <figure>
        <img [src]="ambiancePreview" class="equation-img" alt="Référence" />
        <figcaption>Référence</figcaption>
      </figure>
      <span class="equation-sign">=</span>
      <figure class="equation-result">
        <img *ngIf="resultUrl; else generating" [src]="resultUrl" class="equation-img" alt="Résultat" />
        <ng-template #generating>
          <div class="progress-container">
            <p>Mise en ambiance de l'image… : {{ progress | number:'1.0-0' }}%</p>
            <nb-progress-bar [value]="progress" status="info"></nb-progress-bar>
          </div>
        </ng-template>
        <figcaption>Résultat</figcaption>
      </figure>
    </div>

    <div *ngIf="errorMessage" class="error-message">
      <p><br>{{ errorMessage }}</p>
      <p>Nous vous invitons à vous rapprocher de votre contact Deebr si l'erreur se reproduit.</p>
    </div>
  </nb-card-body>
  <nb-card-footer class="footer-buttons">
    <button nbButton (click)="onCancel()">{{ progressStarted ? 'Fermer' : 'Annuler' }}</button>
    <button nbButton appearance="filled" status="danger" (click)="onGenerate()" *ngIf="!progressStarted" [disabled]="!canGenerate">Générer</button>
    <button nbButton (click)="progressStarted = false" *ngIf="progressStarted && resultUrl">Modifier les réglages</button>
    <button nbButton (click)="onGenerate()" *ngIf="progressStarted && resultUrl">Régénérer</button>
    <button nbButton appearance="filled" status="danger" (click)="onUse()" *ngIf="progressStarted && resultUrl">Utiliser cette image</button>
  </nb-card-footer>
</nb-card>
